import { useMemo, useRef } from 'react';

function setRef<E>(ref: React.Ref<E> | undefined, value: E | null) {
  if (typeof ref === 'function') {
    ref(value);
    // eslint-disable-next-line no-prototype-builtins
  } else if (ref?.hasOwnProperty('current')) {
    // @ts-ignore ref is mutable
    ref.current = value;
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function useJoinRef<E>(
  refA?: React.Ref<E>,
  refB?: React.Ref<E>,
  refC?: React.Ref<E>,
) {
  const ref = useRef<E | null>(null);
  return useMemo(() => {
    return (refValue: E | null) => {
      if (ref.current !== refValue) {
        ref.current = refValue;
        setRef(refA, refValue);
        setRef(refB, refValue);
        setRef(refC, refValue);
      }
    };
  }, [refA, refB, refC]);
}
